var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFill1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0495 2.97856C13.3368 2.69119 13.3368 2.22698 13.0495 1.93961L11.3253 0.215404C11.0379 -0.0719642 10.5737 -0.0719642 10.2863 0.215404L8.93789 1.56383L11.7011 4.32698L13.0495 2.97856ZM0 10.5017V13.2649H2.76316L10.9126 5.1154L8.14947 2.35225L0 10.5017Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill1);
export default __webpack_public_path__ + "static/media/Fill 1.9f76e585dd08254835957aa1a00e2123.svg";
export { ForwardRef as ReactComponent };